export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-enabled-960-70e5f3ab4679407fe8a448e86e51eb29.png";